<template>
    <div class="Avatar bg-primary-400" :style="{width: (radius * 2) + 'px', height: (radius *2) + 'px', 'font-size': (radius * 0.7) + 'px'}">
        {{initials}}
    </div>
</template>

<script>
    export default {
        name: "Avatar",
        props: {
            name: {
                type: String,
                required: true
            },
            radius: {
                type: Number,
                default: 17.5
            }
        },

        computed: {
            initials() {
                return this.name.split(" ").map((n)=>n[0]).join("");
            }
        }
    }
</script>

<style scoped>
    .Avatar {
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>